import { z } from 'zod';
const approveVolunteeringHoursParamsSchema = z.object({
    participationIds: z.string().uuid().array(),
});
export const approveVolunteeringHoursFunctionDef = {
    name: 'approveVolunteeringHours',
    requestSchema: approveVolunteeringHoursParamsSchema,
    responseSchema: z.void(),
};
